<div class="modal-module h-full flex flex-col justify-between">
	<div class="modalHeader">
		<div class="flex">
			<div class="titleNewModule">
				<span>{{
					data.type === 'update' ? translateModal.titleUpdate : translateModal.title
				}}</span>
			</div>
			<div class="closeModal">
				<mat-icon (click)="onNoClick()">close</mat-icon>
			</div>
		</div>
	</div>
	<div class="modalContent overflow-y-auto h-full justify-between flex flex-col">
		<div c lass="w-full h-full pt-4">
			<div class="contentGeneral pt-6 flex">
				<div class="pr-4 w-2/4">
					<form class="h-full" [formGroup]="formGroup">
						<div class="form-group">
							<div class="name-info flex justify-between">
								<label for="name"> {{ translateModal.name }} <span class="asteriks">*</span></label>
								<mat-icon
									class="material-icons-outlined text-sm"
									[pTooltip]="translateModal.textInfo"
									>info</mat-icon
								>
							</div>
							<input
								formControlName="name"
								type="text"
								class="input-app"
								maxlength="50"
								[defaultValue]="data.name ? data.name : ''"
								[placeholder]="translateModal.placeholderName"
							/>
							<div *ngIf="f.name.touched && f.name.invalid" class="alert-error">
								<div *ngIf="f.name.errors?.required">{{ translateModal.nameRequired }}</div>
								<div *ngIf="f.name.errors?.pattern">
									{{ translateModal.regexInvalid }}
								</div>
							</div>
						</div>
						<div class="form-group">
							<label for=""> {{ translateModal.description }} </label>
							<textarea
								formControlName="description"
								[placeholder]="translateModal.placeholderDescription"
							></textarea>
						</div>
					</form>
				</div>
				<div class="pl-4 w-2/4">
					<div class="grid" (dragover)="onDragOver()" (dragleave)="onDragLeave($event)">
						<label for="">{{ translateModal.titleDrag }} </label>
						<div class="inputDrag" [ngClass]="{ 'active-drag': isDragActive }">
							<mat-icon *ngIf="fileUrl === ''" class="mr-2">backup</mat-icon>
							<span *ngIf="fileUrl === ''"> {{ translateModal.textDrag }} </span>
							<img *ngIf="fileUrl !== ''" src="{{ fileUrl }}" class="max-h-48" alt="" />
							<zf-s3-upload-image
								[version]="'1'"
								[url]="'https://res.cloudinary.com/du4jrqkyo/image/upload/v1549938954/picture.jpg'"
								[urlPresigned]="'https://api-services.mango-soft.com/stage/get-presigned-url'"
								[bucket]="'cdn.mango-soft.com'"
								[folder]="'access-control/files'"
								[client]="'zerofractal'"
								[imageZoom]="false"
								(urlUploaded)="urlUploadedHandle($event)"
								(urlUploadedError)="urlUploadedErrorHandle($event)"
							></zf-s3-upload-image>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="footer-modal">
		<div class="px-2">
			<button
				class="mg-button secundaryButton"
				(click)="onNoClick()"
				[matTooltip]="translateModal.buttonCancel"
				[matTooltipPosition]="'above'"
			>
				{{ translateModal.buttonCancel }}
			</button>
		</div>
		<div class="pl-2">
			<button
				[disabled]="formGroup.invalid"
				class="mg-button primaryButton"
				tooltipPosition="top"
				[matTooltip]="translateModal.buttonSave"
				[matTooltipPosition]="'above'"
				(click)="save()"
			>
				{{ translateModal.buttonSave }}
			</button>
		</div>
	</div>
</div>
